module.exports = __webpack_public_path__ + "img/noDNC.c395aa97.png";